import request from "@/utils/request"
/**
 *
 * @param {String|Number} id - id of user to get it's planning
 * @returns {Object} fetched planning response object
 */
export function getAllUserPlannings(id) {
  return request({
    url: `/api/user/${id}/plannings/all`,
    method: "get"
  })
}

/**
 *
 * @param {String|Number} id - id of user to get it's planning
 * @returns {Object} fetched planning response object
 */
export function getAllUserSupportPlannings(id) {
  return request({
    url: `/api/user/${id}/supports/plannings`,
    method: "get"
  })
}

/**
 *
 * @param {String|Number} year - year to get planning for
 * (for planning history)
 * @returns {Object} fetched planning response object
 */
export function fetchPlannings(params) {
  return request({
    url: "/api/plannings",
    method: "get",
    params
  })
}

/**
 *
 * @param {String|Number} id - year to get planning for
 * (for planning history)
 * @returns {Object} fetched planning response object
 */
export function getPlanningsUser(id, videoId) {
  return request({
    url: `/api/user/${id}/supports/plannings/` + videoId,
    method: "get"
  })
}

/**
 * fetches plannings
 * @param {Object} payload - object containing the id video and the id planning
 * @returns {Object} - reponse object
 */
export function deletePlanningVideo({ planningId, videoId }) {
  return request({
    url: `/api/plannings/${planningId}/videos/${videoId}`,
    method: "delete"
  })
}
/**
 *
 * @param  {Object} params - contains the year to get plannings for, and the user id!
 * @returns {Object} fetched planning history response object
 */
export function fetchPlanningsHistory(params) {
  return request({
    url: "/api/plannings/history",
    method: "get",
    params
  })
}

/**
 * Creates a new planning
 * @param {Object} data - planning params object
 * (for planning history)
 * @returns {Object} - created planning response object
 */
export function addNewPlanning(data) {
  if (!data) throw new Error("data were not provided")
  return request({
    url: "/api/plannings",
    method: "post",
    data
  })
}

/**
 * switch use group attribute for a specific planning
 * @param {Object} payload - object containing the month, support id and use group boolean
 * @returns {Object} - reponse object
 */
export function useGroup(data) {
  return request({
    url: "api/plannings/use-group",
    method: "post",
    data
  })
}
/**
 * Adds video to (already created) planning
 * @param {Object} params - added video request params object
 * (for planning history)
 * @returns {Object} - response object
 */
export function addVideoToPlanning(data) {
  if (!data) throw new Error("params were not provided")
  return request({
    url: "/api/plannings/add/videos",
    method: "post",
    data
  })
}

/**
 * switch use group attribute for a specific planning
 * @param {Object} payload - object containing the month, support id and use group boolean
 * @returns {Object} - reponse object
 */
export function validatePlanningVideos(params) {
  return request({
    url: "api/plannings/submit",
    method: "post",
    params
  })
}

/**
 * Creates a new planning in the database (admin)
 * @param {Number|String} id - planning id to fetch
 */
export function fetchSinglePlanning(id) {
  if (!id && typeof +id !== "number") {
    throw new Error("No planning id was given.")
  }
  return request({
    url: "api/plannings/" + id,
    method: "get"
  })
}

/**
 * Creates a new planning in the database (admin)
 * @param {Object} params - request params object
 * @param {Object} data - request data object
 */
export function createPlanning(data, params = {}) {
  return request({
    url: "api/plannings",
    method: "post",
    params,
    data
  })
}

/**
 * Updates a planning from the database (admin)
 * @param {Number|String} id - planning id to update
 * @param {Object} params - request params object
 * @param {Object} data - request data object
 */
export function updatePlanning(id, data, params = {}) {
  if (!id && typeof +id !== "number") {
    throw new Error("No planning id was given.")
  }
  return request({
    url: "api/plannings/" + id,
    method: "put",
    params,
    data
  })
}

/**
 * Accept Request
 *
 * @param {Object} params Request Params
 */
export function updateVodRequest(params = {}) {
  if (params == {} || !params.planning_id || !params.video_id) {
    throw new Error("Error on Parameters")
  }
  let uri
  if (params.stat === 1) {
    uri = "vodAccepted"
  } else if (params.stat === 2) {
    uri = "vodRefused"
  } else {
    throw new Error("Unknown stat")
  }
  return request({
    url: "api/videos/" + uri,
    method: "post",
    params
  })
}

/**
 * Deletes a planning from the database (admin)
 * @param {Number|String} id - planning id to delete
 * @param {Object} params - request params object
 */
export function deletePlannig(planningId, params = {}) {
  return request({
    url: `api/plannings/${planningId}`,
    method: "delete",
    params
  })
}

/**
 * Increments a planning's premium slots' count from the database (admin)
 * @param {Number|String} id - planning id to update
 */
export function purchasePremiumSlot(id) {
  if (!id && typeof +id !== "number") {
    throw new Error("No planning id was given.")
  }
  return request({
    url: "api/plannings/" + id + "/slot",
    method: "post"
  })
}

/**
 * Increments a planning's premium slots' count from the database (admin)
 * @param {Number|String} id - planning id to update
 */
export function getFullPlannings(video) {
  return request({
    url: `api/users/plannings/${video}/unavailable`,
    method: "get"
  })
}

/**
 * Upload an excel file for videos cost per pharmacy per planning
 * @param {Object} data - excel file
 */
export function uploadPrices(data) {
  return request({
    url: `api/plannings/prices`,
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  })
}

export function downloadRequestFile(fileName) {
  return request({
    url: "/api/plannings/download/" + fileName,
    method: "get",
    responseType: "blob"
  })
}
